import ModalRelatedProductsPresenter from "../components/modal-related-products/presenter/modal-related-products.js";

const modalRelatedProductsComponent = new ModalRelatedProductsPresenter();
modalRelatedProductsComponent.init();
